import React, { useState, useEffect, useRef } from 'react';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import LoadingPanel from 'views/widgets/LoadingPanel.jsx';
import InputView from 'views/widgets/InputView.jsx';

export default function MfaDialog(props) {

	const { authenticatedCallback, cancelCallback, username, loadPreferencesFromStateCallback, mfaAuthorizeDeviceFailedCallback } = props;
	const [state, setState] = useState({ valid: false, token: "", masked: false });
	const tokenRef = useRef();
	
	useEffect(() => {
    	tokenRef.current.focus();
  	}, []);
	
	const tokenChanged = (event) => {
		let token = event.value;
		let valid = token && token != null && token.trim() != '';
		setState({ valid: valid, token: event.value });
	};
	
	const verifyToken = (token) => {
		// if invalid, error and exit
		let options = {
			credentials: 'include',
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: token
		}
		setState({ ...state, masked: true });
		fetch(API_URL + '/verify_token', options
		).then((response) => {
			if (response.ok) return response.json();
			else { throw new Error(response.status); }
		}).then((json) => {
			setState({ ...state, masked: false });
			loadPreferencesFromStateCallback();
			authenticatedCallback();
		}).catch((err) => {
			setState({ ...state, masked: false });
			mfaAuthorizeDeviceFailedCallback("Authorize device failed to verify code.");
		});
	};
	
	return (
		<Dialog 
			className="constituo-mfa-dialog"
			title="Authorize Device" 
			onClose={cancelCallback}
		>	
			<p tabindex="0" role="region" class='verify-info'><span class="verify-user">{username}</span> has not authorized this device. Please check your email for a verification code.</p>
			<p tabindex="0" role="region" class='verify-info'>Enter the verification code below to authorize <br/><span class="verify-user">{username}</span> <br/> on this device.</p>
			
			<InputView
				tabindex="0"
				ref={tokenRef}
				field='token'
				type='text'
				label='Verification Code:'
				value={state.token}
				autoSelectOnFocus={true}
				valid={state.valid}
				onChange={tokenChanged}
			/>
		    <DialogActionsBar>
        		<button
        			tabindex="0"
					aria-label="Confirm"
            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              		onClick={() => { verifyToken(state.token); }}
              		disabled={!state.valid}
            	>
            		Confirm
            	</button>
            	<button
            		tabindex="0"
					aria-label="Cancel"
            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            		onClick={cancelCallback}
            	>
             		Cancel
            	</button>
	        </DialogActionsBar>
	        
	        {state.masked && <LoadingPanel />}
		</Dialog>	        
	);
}